export default "__VITE_ASSET__AdeQW7Ix__"